import React from 'react';
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react';
import {
  ComputerDesktopIcon,
  MoonIcon,
  SunIcon,
} from '@heroicons/react/24/outline';
import clsx from 'clsx';
import { useTheme } from './ThemeProvider';

const OPTIONS = [
  { value: 'light', label: 'Light', Icon: SunIcon },
  { value: 'dark', label: 'Dark', Icon: MoonIcon },
  { value: 'system', label: 'System', Icon: ComputerDesktopIcon },
];

const ThemeToggle = () => {
  const { theme, resolvedTheme, setTheme } = useTheme();
  const TriggerIcon = resolvedTheme === 'dark' ? MoonIcon : SunIcon;
  const isDark = resolvedTheme === 'dark';

  return (
    <Menu as="div" className="relative">
      <MenuButton
        className={clsx(
          'flex items-center rounded-md p-1.5',
          isDark
            ? 'text-zinc-300 hover:bg-zinc-800'
            : 'text-zinc-700 hover:bg-zinc-100',
        )}
        aria-label={`Theme: ${theme}`}
      >
        <TriggerIcon aria-hidden="true" className="size-5" />
        <span className="sr-only">Change theme</span>
      </MenuButton>
      <MenuItems
        transition
        anchor="bottom end"
        className={clsx(
          'z-50 mt-2 w-40 origin-top-right rounded-md py-1 shadow-lg ring-1 transition data-closed:scale-95 data-closed:opacity-0 data-enter:duration-100 data-enter:ease-out data-leave:duration-75 data-leave:ease-in',
          isDark ? 'bg-zinc-900 ring-white/10' : 'bg-white ring-black/5',
        )}
      >
        {OPTIONS.map(({ value, label, Icon }) => (
          <MenuItem key={value}>
            {({ focus }) => (
              <button
                type="button"
                onClick={() => setTheme(value)}
                className={clsx(
                  'flex w-full items-center gap-2 px-3 py-2 text-left text-sm',
                  focus
                    ? isDark
                      ? 'bg-zinc-800 text-zinc-100'
                      : 'bg-zinc-100 text-zinc-900'
                    : isDark
                      ? 'text-zinc-300'
                      : 'text-zinc-700',
                  theme === value && 'font-semibold',
                )}
              >
                <Icon aria-hidden="true" className="size-4" />
                <span>{label}</span>
                {theme === value && (
                  <span
                    aria-hidden="true"
                    className={clsx('ml-auto text-xs', isDark ? 'text-zinc-500' : 'text-zinc-400')}
                  >
                    ✓
                  </span>
                )}
              </button>
            )}
          </MenuItem>
        ))}
      </MenuItems>
    </Menu>
  );
};

export default ThemeToggle;
